module.exports = __webpack_public_path__ + "static/img/homebanner.df8793f.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/homebanner.png
// module id = hsC9
// module chunks = 9